module.exports = __webpack_public_path__ + "static/media/search-footer.d26f040b.png";